import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEmpty, get } from 'lodash-es'

import { WebinarSidebarFeature } from '../../../../sharedLegacy/features'
import { useInvalidatePollsQuery } from '../../Tray/hooks/use-polls'
import { getIsDraft } from '../../../selectors'
import {
  toggleQuestionOverlay as toggleQuestionOverlayAction,
  togglePollOverlay as togglePollOverlayAction,
} from '../../../actions'
import { useRoomGlobalInfo } from '../../../../global/blocs/roomInfo'
import { useSiteQuery } from '../../../../global/blocs/useSite'

const Sidebar = ({
  /**
   * Connected properties
   */
  role,
  liveData,
  localParticipantName,
  isDraft,
  webinarLink,
  isInGearMode,
  questionOverlayCommentId,

  /**
   * Connected functions
   */
  toggleQuestionOverlay,
  togglePollOverlay,
}) => {
  const { liveId, presenterToken } = useRoomGlobalInfo()
  const { data: siteData } = useSiteQuery()

  const invalidate = useInvalidatePollsQuery(liveId)

  if (isEmpty(liveData)) {
    return null
  }

  const webinarViewLink =
    webinarLink && `${siteData?.https_url ?? ''}${webinarLink}`

  return (
    <WebinarSidebarFeature
      namespace="webinar-room-sidebar"
      role={role}
      liveId={liveId}
      liveData={liveData}
      token={liveData.token}
      defaultSidebarTab="audience"
      localParticipantName={localParticipantName}
      presenterToken={presenterToken}
      webinarViewLink={webinarViewLink}
      isDraft={isDraft}
      isQuestionsEnabledDefault={get(liveData, 'question_mode') === 'ask'}
      toggleQuestionOverlay={toggleQuestionOverlay}
      questionOverlayCommentId={questionOverlayCommentId}
      togglePollOverlay={togglePollOverlay}
      isInGearMode={isInGearMode}
      onInvalidatePolls={invalidate}
    />
  )
}

Sidebar.propTypes = {
  /**
   * Connected properties
   */
  role: PropTypes.oneOf(['presenter', 'producer']),
  liveData: PropTypes.object,
  localParticipantName: PropTypes.string,
  isDraft: PropTypes.bool,
  webinarLink: PropTypes.string,
  isInGearMode: PropTypes.bool,
  questionOverlayCommentId: PropTypes.string,

  /**
   * Connected functions
   */
  toggleQuestionOverlay: PropTypes.func,
  togglePollOverlay: PropTypes.func,
}

const mapStateToProps = (state) => ({
  /**
   * Connected properties
   */
  role: state.webinar.role,
  liveData: state.webinar.liveData,
  localParticipantName: state.webinar.localParticipantName,
  isDraft: getIsDraft(state),
  webinarLink: state.webinar.liveData.link,
  isInGearMode: state.webinar.isGearMode,
  liveId: state.webinar.liveId,
  questionOverlayCommentId: state.webinar.questionOverlayCommentId,
})

const mapDispatchToProps = {
  /**
   * Connected functions
   */
  toggleQuestionOverlay: toggleQuestionOverlayAction,
  togglePollOverlay: togglePollOverlayAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)
